import { useContext } from 'react';

import { CampaignRegisterContext } from './CampaignRegisterContext';

export const useCampaignContext = () => {
  return useContext(CampaignRegisterContext);
};
